import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18nify';
import EditModal from '../modal/EditModal';
import AddPolicy from '../../containers/advanced_filtering/AddPolicy';

const AddPolicyModal = ({ showModal, closeDialog, buttonAction, disabled }) => (
  <EditModal
    title={translate('components.advancedFiltering.create')}
    showModal={showModal}
    buttonAction={buttonAction}
    closeDialog={closeDialog}
    saveBtnText={translate('shared.create')}
    disabled={disabled}
  >
    <AddPolicy />
  </EditModal>
);

AddPolicyModal.propTypes = {
  showModal: PropTypes.bool.isRequired,
  closeDialog: PropTypes.func.isRequired,
  buttonAction: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  hideNetwork: PropTypes.bool,
};

AddPolicyModal.defaultProps = {
  disabled: false,
};

export default AddPolicyModal;
